import { MenuOptions } from "react-native-popup-menu";
export default MenuOptions;
